import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { AdminShell } from "@/features/admin/admin-shell";
import { ensureMe } from "@/hooks/data";
import { isApiError } from "@/lib/api/errors";
import { adoptSession, isPlatformAdmin } from "@/lib/auth";

/**
 * Platform admin console (Malfak staff), ALP-85: its own shell (top bar + tabs), separate from the customer app, so the
 * customer navigation never shows here. Everything under /admin requires `user.platformRole === "platform_admin"`;
 * anyone else gets a plain 404 (the area's existence isn't revealed), signed-out visitors go to sign-in. The API
 * enforces the same rule on /v1/admin/* (403).
 */
export const Route = createFileRoute("/admin")({
  beforeLoad: async ({ context, location }) => {
    let me;
    try {
      me = await ensureMe(context.queryClient);
    } catch (e) {
      if (isApiError(e) && e.isUnauthorized) throw redirect({ to: "/login", search: { redirect: location.href } });
      throw e;
    }
    if (!isPlatformAdmin(me)) throw notFound();
    adoptSession(me);
  },
  component: AdminShell,
});
